import { CompleteRegisterGuard } from '@shared/guards/complete.register.guard';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { NewUserPage } from './new-user.page';

const routes: Routes = [
  {
    path: '',
    component: NewUserPage,
  },
  {
    path: 'cadastro-realizado',
    // canLoad: [CompleteRegisterGuard],
    loadChildren: () =>
      import('./complete-register/complete-register.module').then(m => m.CompleteRegisterPageModule),
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class NewUserPageRoutingModule {}
